import $ from "jquery";

//Individual bootstrap plugins
import "bootstrap/js/dist/util";
import "bootstrap/js/dist/dropdown";
import "bootstrap/js/dist/modal";
import "bootstrap/js/dist/popover";
// import 'bootstrap/js/dist/button';
import "bootstrap/js/dist/collapse";
import "bootstrap/js/dist/carousel";
// import 'bootstrap/js/dist/scrollspy';

import general from "./general.js";
import forms from "./modules/forms";
import favorites from "./modules/favorites";
import header from "./modules/header";
import checkout from "./modules/checkout.js";
import cart from "./modules/cart";
import lightbox from "./modules/lightbox";
import zipToCity from "./modules/zipToCity.js";
import zipValidation from "./modules/zipValidation.js";
import swiper from "./modules/swiper.js";
import logoAnimation from "./modules/logoAnimation.js";
import "./modules/ui-to-top.js";
import tracking from "./utils/datalayer.js";

window.tracking = tracking;

document.addEventListener("DOMContentLoaded", () => {
  general.init();
  forms.init();
  favorites.init();
  header.init();
  cart.init();
  checkout.init();
  lightbox.init();
  zipToCity.init();
  zipValidation.init();
  swiper.init();
  logoAnimation.init();

  $(function() {
    $('[data-toggle="popover"]').popover();
  });
});

window.$ = window.jQuery = $;
